import { render, staticRenderFns } from "./FixNewAppointment.vue?vue&type=template&id=d2b19ac6&scoped=true&"
import script from "./FixNewAppointment.vue?vue&type=script&lang=js&"
export * from "./FixNewAppointment.vue?vue&type=script&lang=js&"
import style0 from "./FixNewAppointment.vue?vue&type=style&index=0&id=d2b19ac6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2b19ac6",
  null
  
)

export default component.exports